// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"acc52ee3","677":"7a99d44b","767":"e823892d"}[chunkId] + ".chunk.css";
};